import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Add from '!svg-react-loader?!images-react-svg/icons_v2/add.svg';
import AutoShip from '!svg-react-loader?!images-react-svg/icons_v2/auto-ship.svg';
import Close from '!svg-react-loader?!images-react-svg/icons_v2/close.svg';

const ShopButton = props => {
  const buttonClasses = classNames('shop-button', props.className, {
    [`shop-button--${props.color}`]: props.color,
    'shop-button--wide': props.wide,
  });

  const icon = () => {
    if (props.disabled) {
      return Close;
    } else if (props.color === 'auto-ship') {
      return AutoShip;
    } else if (props.removeItem) {
      return Close;
    }

    return Add;
  };

  const Icon = icon();

  const handleClick = event => {
    if (!props.disabled) {
      props.onClick && props.onClick(event);
    }
  };

  return (
    <button
      className={buttonClasses}
      disabled={props.disabled}
      onClick={handleClick}
    >
      <span className="shop-button__text text--button">{props.children}</span>
      <Icon className="shop-button__icon" />
    </button>
  );
};

ShopButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(['auto-ship', 'carrot', 'light']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  wide: PropTypes.bool,
};

export default ShopButton;
